import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::showLoginFormInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:176
* @route '/organizer/login'
*/
export const showLoginFormInertia = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showLoginFormInertia.url(options),
    method: 'get',
})

showLoginFormInertia.definition = {
    methods: ["get","head"],
    url: '/organizer/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::showLoginFormInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:176
* @route '/organizer/login'
*/
showLoginFormInertia.url = (options?: RouteQueryOptions) => {
    return showLoginFormInertia.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::showLoginFormInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:176
* @route '/organizer/login'
*/
showLoginFormInertia.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showLoginFormInertia.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::showLoginFormInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:176
* @route '/organizer/login'
*/
showLoginFormInertia.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: showLoginFormInertia.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::showLoginFormInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:176
* @route '/organizer/login'
*/
const showLoginFormInertiaForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showLoginFormInertia.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::showLoginFormInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:176
* @route '/organizer/login'
*/
showLoginFormInertiaForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showLoginFormInertia.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::showLoginFormInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:176
* @route '/organizer/login'
*/
showLoginFormInertiaForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showLoginFormInertia.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

showLoginFormInertia.form = showLoginFormInertiaForm

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::loginInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:187
* @route '/organizer/login'
*/
export const loginInertia = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: loginInertia.url(options),
    method: 'post',
})

loginInertia.definition = {
    methods: ["post"],
    url: '/organizer/login',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::loginInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:187
* @route '/organizer/login'
*/
loginInertia.url = (options?: RouteQueryOptions) => {
    return loginInertia.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::loginInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:187
* @route '/organizer/login'
*/
loginInertia.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: loginInertia.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::loginInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:187
* @route '/organizer/login'
*/
const loginInertiaForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: loginInertia.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::loginInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:187
* @route '/organizer/login'
*/
loginInertiaForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: loginInertia.url(options),
    method: 'post',
})

loginInertia.form = loginInertiaForm

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::logoutInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:229
* @route '/organizer/logout'
*/
export const logoutInertia = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: logoutInertia.url(options),
    method: 'get',
})

logoutInertia.definition = {
    methods: ["get","head"],
    url: '/organizer/logout',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::logoutInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:229
* @route '/organizer/logout'
*/
logoutInertia.url = (options?: RouteQueryOptions) => {
    return logoutInertia.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::logoutInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:229
* @route '/organizer/logout'
*/
logoutInertia.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: logoutInertia.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::logoutInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:229
* @route '/organizer/logout'
*/
logoutInertia.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: logoutInertia.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::logoutInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:229
* @route '/organizer/logout'
*/
const logoutInertiaForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: logoutInertia.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::logoutInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:229
* @route '/organizer/logout'
*/
logoutInertiaForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: logoutInertia.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\LoginController::logoutInertia
* @see app/Http/Controllers/Organizer/Auth/LoginController.php:229
* @route '/organizer/logout'
*/
logoutInertiaForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: logoutInertia.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

logoutInertia.form = logoutInertiaForm

const LoginController = { showLoginFormInertia, loginInertia, logoutInertia }

export default LoginController